import './legal-links-stack.scss';
import {Link, Stack} from '@mui/material';
import {translations} from '../../i18n/translations';
import {useContext} from 'react';
import {AppContextType} from '../../contexts/app/types';
import {AppContext} from '../../contexts/app/context';
import {useTranslation} from 'react-i18next';
import i18next from 'i18next';
import {getTranslatedLegalDocuments} from '../../utils/functions/get-translated-legal-documents';

/**
 * Legal links component used in the public screens.
 */
export const LegalLinksStack = (props: {paddingTop?: string}) => {
  // Get context
  const appContext: AppContextType = useContext(AppContext);

  // Translations
  const {t} = useTranslation();

  const legalDocuments = getTranslatedLegalDocuments(
    appContext.state.configuration.legalDocuments,
    i18next.language
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{paddingTop: props.paddingTop ? props.paddingTop : '0px'}}
      className="legal-docs-links"
    >
      <Link
        className="legal-docs-link"
        color="inherit"
        target="_blank"
        href={legalDocuments.privacyPolicyUrl}
        fontSize="16px"
      >
        {t(translations.legal_documents.privacy_policy as string)}
      </Link>
      <Link
        className="legal-docs-link"
        color="inherit"
        target="_blank"
        href={legalDocuments.termsOfUseUrl}
        fontSize="16px"
      >
        {t(translations.legal_documents.terms_and_conditions as string)}
      </Link>
    </Stack>
  );
};
